import Sections from '~/components/roadmap/roadmap-items'
import { H2, TextL } from '~/tenset-components'

export function RoadmapRoadmap() {
  return (
    <div className="flex flex-col gap-4">
      <H2 isBold>Roadmap 2024 & 2025</H2>

      <TextL className="max-w-screen-lg">
        Discover the detailed plan for achieving the goals. Excitement surrounds
        the potential destinations these objectives will lead to, and hard work
        is underway to make it happen.
      </TextL>

      <Sections />
    </div>
  )
}
